import { CircleDollarSign } from 'lucide-react';
import { createElement } from 'react';

import type { KhaiBaoModule } from '../../lib/modules.js';
import { TrangDoanhThu } from './pages/TrangDoanhThu.js';
import { TrangDoiSoat } from './pages/TrangDoiSoat.js';
import { TrangNhapDoanhThu } from './pages/TrangNhapDoanhThu.js';

const revenue: KhaiBaoModule = {
  id: 'revenue',
  nav: {
    group: 'TÀI CHÍNH',
    label: 'Doanh thu',
    icon: CircleDollarSign,
    order: 1,
    permission: 'revenue',
    to: '/doanh-thu',
  },
  routes: [
    {
      path: '/doanh-thu',
      element: createElement(TrangDoanhThu),
      permission: { module: 'revenue', level: 'view' },
    },
    {
      path: '/doanh-thu/nhap',
      element: createElement(TrangNhapDoanhThu),
      permission: { module: 'revenue', level: 'edit' },
    },
    {
      path: '/doanh-thu/doi-soat',
      element: createElement(TrangDoiSoat),
      permission: { module: 'revenue', level: 'view' },
    },
  ],
};

export default revenue;
